import { Alert, Icons } from '@commenda/kakashi';

interface OverlapWarningAlertProps {
  message: string;
  onAdjustPeriod?: () => void;
}

export function OverlapWarningAlert({
  message,
  onAdjustPeriod,
}: OverlapWarningAlertProps) {
  return (
    <Alert
      variant="warning"
      icon={<Icons.AlertCircle className="size-5 text-text-warning" />}
      title="Overlapping tax period"
      description={message}
      action={
        onAdjustPeriod
          ? {
              label: 'Adjust period',
              onClick: onAdjustPeriod,
              variant: 'tertiary',
            }
          : undefined
      }
    />
  );
}
